const styles = (theme) => ({
  container: { width: "100%", p: 2 },
  mainPaper: {
    padding: { xs: "20px", md: "30px" },
    borderRadius: "16px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 1,
    p: 4,
  },
  title: { fontWeight: "bold", fontSize: "20px" },
  header: { display: "flex", alignItems: "center", gap: 1, mb: 2 },
  macrosContainer: {
    backgroundColor: theme.palette.background.wallpaper,
    p: 2,
    borderRadius: "16px",
  },
  macroRow: {
    transition: "all 0.3s ease",
    opacity: 1,
  },
  macroField: { flex: 1 },
  descriptionField: { flex: 1.5 },
  deleteButton: { width: 40, height: 40 },
  addButton: { fontWeight: "bold" },
  divider: { mt: 4, mb: 3 },
  actionButton: { px: 4 },
});

export default styles;
